import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { AdUnitForPageTransferListDTO } from './types'

export const AD_UNIT_FOR_PAGE_TRANSFER_LIST_FRAGMENT = (
  ability: Ability,
): TypedDocumentNode<AdUnitForPageTransferListDTO> => gql`
  fragment AdUnitForPageTransferList on AdUnit {
    ${permitFields<AdUnitForPageTransferListDTO>({
      ybAdUnitEnabled: ability.can('read', 'AdUnitField-ybAdUnitEnabled'),
    })}
    id
    path
  }
`
